import {Injectable} from '@angular/core';
import {AuthService} from './auth';

@Injectable({ providedIn: 'root' })
export class AppVersionService {
    private readonly cacheVersionKey = 'cache_version';
    private readonly cacheVersionValue = '1.0.8';

    constructor(private authService: AuthService) {}

    async checkAndClearCacheIfNeeded(): Promise<void> {
        // Ne pas se déconnecter (ni déconnecter les autres onglets) pendant le traitement du retour Okta :
        // la purge est faite au prochain chargement
        if (window.location.pathname.startsWith('/login/callback')) {
            return;
        }
        const savedCacheVersion = localStorage.getItem(this.cacheVersionKey);
        if (savedCacheVersion && savedCacheVersion !== this.cacheVersionValue) {
            console.warn(`App version changed: ${this.cacheVersionKey} -> ${this.cacheVersionValue}. Clearing caches.`);
            localStorage.setItem(this.cacheVersionKey, this.cacheVersionValue);
            await this.authService.logout();
        }
        localStorage.setItem(this.cacheVersionKey, this.cacheVersionValue);
    }
}
